import { useRef, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import authProvider from '../../../../../../../core/AuthenticationProvider'
import { Element } from '../../../../../../common/html/element'
import DropdownTooltip from '../../../../../../common/textEllipsis/DropdownTooltip'

export const DownloadCell = ({ val, isDisabled, isExpired }) => {
  const downloadCellRef = useRef()

  const [isOpenTooltip, setIsOpenTooltip] = useState(false)

  const onClick = () => {
    if (isDisabled || isExpired) return
    authProvider.getUser().then((user) => {
      window.location.href = `${process.env.REACT_APP_SERVICE_ENDPOINT}/Report/Export?OrderDetailId=${val}&access_token=${user.access_token}`
    })
  }

  const onMouseEnter = () => {
    if (isExpired && !isDisabled) {
      setIsOpenTooltip(true)
    }
  }

  const onMouseLeave = () => {
    if (isExpired && !isDisabled) {
      setIsOpenTooltip(false)
    }
  }

  return (
    <>
      <Element
        elementName="span"
        style={{
          color: '#2C73E8',
          cursor: 'pointer',
          opacity: isDisabled || isExpired ? 0.6 : 1,
        }}
        onClick={onClick}
        ref={downloadCellRef}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Translate value="userManagement.orderManagement.orderDetail.DOWNLOAD" />
      </Element>
      {isOpenTooltip && (
        <DropdownTooltip
          containerRef={downloadCellRef}
          text={'userManagement.orderManagement.orderDetail.EXPIRED_FILE'}
          isOpenTooltip={isOpenTooltip}
          zIndexTooltip={999}
          isI18n
        />
      )}
    </>
  )
}
